<div class="p-4">
    <app-privacy-policy></app-privacy-policy>
</div>